// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2y-2";
export var placeholderIcon = "_2y-3";
export var thumbnailCanvas = "_2y-1";
export var thumbnailWrapper = "_2y-0";